import { TabContent, Row, Col, CardTitle, CardText, Button } from 'reactstrap';
import source from '@src/assets/images/pages/create-account.svg';
import logo from '@src/assets/images/logo/logo.png';
import { Link, useHistory } from 'react-router-dom';
import { Power } from 'react-feather';
import { useEffect, useMemo, useState } from 'react';
import api from '@src/services/api';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { handleLogout } from '@store/actions/auth';
import useJwt from '@src/auth/jwt/useJwt';
import { useBrand } from '@src/utility/hooks/useBrand';
import PermissionDevice from './PermissionDevice';
import Preparation from './Preparation';
import WhichDocument from './WhichDocument';
import SendDocument from './SendDocument';
import OtherInfo from './OtherInfo';
import SendFace from './SendFace';
import PreparationSelfie from './PreparationSelfie';
import SendProof from './SendProof';
import FinishedDocument from './FinishedDocument';
import { TermsService } from '../AcceptTerms';

interface Finances {
  monthlyInvoicing: string;
  shareCapital?: string;
  patrimony?: string;
}

interface OtherInfoInterface {
  marital?: string;
  education?: string;
  rg?: string;
  rgIssuer?: string;
  rgIssuedDate?: string;
  softwareDescriptor?: string;
}

interface OIdata {
  idOperator: string;
  finances: Finances;
  otherInfo?: OtherInfoInterface;
  document: string;
}
interface SendProofProps {
  handleChangeTabe: (tab: string) => void;
  request?: Record<string, unknown>;
  otherInfoData: OIdata;
}
export function SendDocumentary() {
  const { brand, nameTab } = useBrand();
  const [activeTab, setActiveTab] = useState('1');
  const [otherInfoData, setOtherInfoData] = useState<OIdata | null>(null);
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const history = useHistory();
  const [request, setRequest] = useState({
    idOperator: '',
    typeDocument: '',
    type: '',
  });
  const handleGetIdOperator = (idOperator: string) => {
    setRequest((req) => {
      req.idOperator = idOperator;
      return req;
    });
  };

  const handleGetTypeForDocument = (typeDocument: string) => {
    setRequest((req) => {
      req.typeDocument = typeDocument;
      return req;
    });
  };

  const handleGetType = (type: string) => {
    setRequest((req) => {
      req.type = type;
      return req;
    });
  };

  const handleChangeTabe = (tab: string) => {
    setActiveTab(tab);
  };
  const handleOtherInfoData = (data: OIdata) => {
    setOtherInfoData(data);
  };

  const handleClickLogout = async () => {
    api.post('logout', null, {
      headers: {
        Authorization: `Bearer ${useJwt.getToken()}`,
      },
    });

    dispatch(handleLogout());

    queryClient.removeQueries();

    history.push('/login');
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('userData') as string);
    if (data) {
      if (data.verify_documents === 1) {
        setActiveTab('10');
      }
    }
  }, []);

  const memoizedPermissionDevice = useMemo(() => {
    return <PermissionDevice handleChangeTabe={handleChangeTabe} />;
  }, []);

  const memoizedPreparation = useMemo(() => {
    return <Preparation handleChangeTabe={handleChangeTabe} />;
  }, []);

  const memoizedWhichDocument = useMemo(() => {
    return (
      <WhichDocument
        handleChangeTabe={handleChangeTabe}
        handleGetIdOperator={handleGetIdOperator}
        handleGetTypeForDocument={handleGetTypeForDocument}
        handleGetType={handleGetType}
      />
    );
  }, []);

  return (
    <>
      <div className="auth-wrapper auth-v2">
        <Row className="auth-inner m-0">
          <Col
            className="d-none d-lg-flex align-items-center p-0 position-relative"
            lg="3"
            sm="12"
          >
            <div className="w-100 d-lg-flex align-items-center justify-content-center">
              <img className="img-fluid w-100" src={source} alt="Login Cover" />
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link
                className="brand-logo position-absolute"
                style={{
                  top: '10%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
                to="#"
              >
                {nameTab.toLowerCase() !== 'ultrapayments' ? (
                  <img
                    src={brand}
                    alt={`Logo ${nameTab}`}
                    className="img-fluid"
                  />
                ) : (
                  <img
                    src={logo}
                    alt="Logo Ultrapayments"
                    className="img-fluid"
                  />
                )}
              </Link>
            </div>
          </Col>

          <Col
            className="auth-bg px-2 px-sm-3 px-lg-5 pt-3 mb-5 pb-3"
            lg="9"
            sm="12"
          >
            <Row className="justify-content-center">
              <Col className="d-flex flex-column justify-content-center align-items-center">
                <CardTitle className="mb-1" tag="h1">
                  Atualização de Documentos
                </CardTitle>
                <CardText className="mb-2">
                  O envio de documentos é necessário para continuar usando
                  nossos serviços.
                </CardText>
              </Col>
            </Row>
            <div className="d-flex justify-content-end">
              <button
                style={{ bottom: 20, right: 20 }}
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => handleClickLogout()}
              >
                <Power size={14} className="mr-75" />
                <span className="align-middle">Sair</span>
              </button>
            </div>
            <hr style={{ paddingBottom: '30px' }} />
            <TabContent activeTab={activeTab}>
              {memoizedPermissionDevice}
              {memoizedPreparation}
              {memoizedWhichDocument}

              <SendDocument
                handleChangeTabe={handleChangeTabe}
                activeTab={activeTab}
                request={request}
                title="Frente"
                description="Foque a frente do seu documento na câmera."
                actualTab="4"
                nextTab="5"
                frontOrBack="FRONT"
              />

              <SendDocument
                handleChangeTabe={handleChangeTabe}
                activeTab={activeTab}
                request={request}
                title="Verso"
                description="Foque o verso do seu documento na câmera."
                actualTab="5"
                nextTab="6"
                frontOrBack="BACK"
              />

              <PreparationSelfie handleChangeTabe={handleChangeTabe} />

              <SendFace
                handleChangeTabe={handleChangeTabe}
                activeTab={activeTab}
                request={request}
              />

              <OtherInfo
                handleChangeTabe={handleChangeTabe}
                request={request}
                otherInfoDataChange={handleOtherInfoData}
              />

              <SendProof
                handleChangeTabe={handleChangeTabe}
                request={request}
                otherInfoData={otherInfoData}
              />

              <FinishedDocument />
            </TabContent>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default SendDocumentary;
